/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

export const PiButtonIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="8" fill="url(#paint0_linear_6328_164609)" />
        <path
            d="M15.2429 8.21699C15.4895 7.49504 16.5105 7.49504 16.7571 8.21699L17.5938 10.6672C18.1941 12.4251 19.5749 13.8059 21.3328 14.4062L23.783 15.2429C24.505 15.4895 24.505 16.5105 23.783 16.7571L21.3328 17.5938C19.5749 18.1941 18.1941 19.5749 17.5938 21.3328L16.7571 23.783C16.5105 24.505 15.4895 24.505 15.2429 23.783L14.4062 21.3328C13.8059 19.5749 12.4251 18.1941 10.6672 17.5938L8.21699 16.7571C7.49504 16.5105 7.49504 15.4895 8.21699 15.2429L10.6672 14.4062C12.4251 13.8059 13.8059 12.4251 14.4062 10.6672L15.2429 8.21699Z"
            fill="white"
        />
        <path
            d="M22.6173 6.25725C22.7324 5.87921 23.2676 5.87921 23.3827 6.25725L23.7781 7.55642C23.8751 7.8753 24.1247 8.12485 24.4436 8.22191L25.7427 8.61733C26.1208 8.7324 26.1208 9.2676 25.7427 9.38267L24.4436 9.77809C24.1247 9.87515 23.8751 10.1247 23.7781 10.4436L23.3827 11.7427C23.2676 12.1208 22.7324 12.1208 22.6173 11.7427L22.2219 10.4436C22.1249 10.1247 21.8753 9.87515 21.5564 9.77809L20.2573 9.38267C19.8792 9.2676 19.8792 8.7324 20.2573 8.61733L21.5564 8.22191C21.8753 8.12485 22.1249 7.8753 22.2219 7.55642L22.6173 6.25725Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_6328_164609"
                x1="-2.38419e-07"
                y1="16"
                x2="32"
                y2="16"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3E6FE5" />
                <stop offset="1" stopColor="#8241E7" />
            </linearGradient>
        </defs>
    </svg>
);
